import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Separator } from '../../../../../common/separator'
import StatusTag from '../../../../../common/statusTag'
import { TextEllipsisStaticLine } from '../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { upperCaseFirstLetter } from '../../../../../helpers/common'
import { formatText } from '../../../../../helpers/value'
import { Action } from '../action'
import { CreditRiskScore } from '../creditRiskScore'
import classes from './index.module.scss'

export const Detail = ({ data }) => {
  const {
    activeStatusId,
    activeStatusName,
    listingStatusName,
    vsicName,
    score,
    scoreColor,
    taxCode,
    ticker,
    organizationShortName,
    prevScore,
    organizationNameAlternate,
    scoreColor: scoreColorNotPremium,
    scoreTrending: trendingNotPremium,
  } = data

  return (
    <div className="w100">
      <div className="dFlex justifyContentStart alignItemsCenter">
        <StatusTag status={activeStatusId} label={activeStatusName} />
        <span className={classes.value}>
          {upperCaseFirstLetter(listingStatusName)}
        </span>
        <Separator
          backgroundColor="#9c9c9c"
          width={1}
          height={16}
          margin={'0 16px'}
        />
        <div>
          <Translate
            value="companyAnalysis.common.MAIN_BUSINESS"
            className="fw600"
          />
          <span className={classes.value}>{formatText(vsicName)}</span>
        </div>
      </div>

      <CreditRiskScore
        score={score}
        prevScore={prevScore}
        dataWhenDisable={{
          color: scoreColorNotPremium,
          trending: trendingNotPremium,
        }}
        scoreColor={scoreColor}
      />

      <div className="dFlex justifyContentBetween alignItemsEnd">
        <div className={classes.companyDetailInfo}>
          <div className={[classes.column, classes.leftColumn].join(' ')}>
            <Translate value="companyAnalysis.common.TAX_CODE" />
            <Translate value="companyAnalysis.common.TICKER_SYMBOL" />
            <Translate value="companyAnalysis.common.VIETNAMESE_NAME" />
            <Translate value="companyAnalysis.common.SHORT_NAME" />
          </div>
          <div className={[classes.column, classes.rightColumn].join(' ')}>
            <div>{formatText(taxCode)}</div>
            <div>{formatText(ticker)}</div>
            <div>
              <TextEllipsisStaticLine
                text={formatText(organizationNameAlternate)}
                lineClamp={1}
                isI18n={false}
              />
            </div>
            <div>{formatText(organizationShortName)}</div>
          </div>
        </div>
        <Action />
      </div>
    </div>
  )
}

Detail.propTypes = {
  data: PropTypes.shape({
    listingStatusName: PropTypes.string,
    activeStatusName: PropTypes.string,
    organizationName: PropTypes.string,
    score: PropTypes.number,
    taxCode: PropTypes.string,
    organizationShortName: PropTypes.string,
    ticker: PropTypes.string,
    vsicName: PropTypes.string,
  }).isRequired,
}
